import { Divider, Grid, Typography, Box } from "@mui/material";
import { InputField } from "../../../../utils/FormFields";
import CountryField from "../../../../utils/FormFields/CountryField";

export default function EmployeeAddress(props: any) {
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Address
      </Typography>
      <Divider />
      <Grid
        container
        rowSpacing={4}
        spacing={2}
        sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}
      >
        <Grid xs={12} sm={5}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Address.Street" label="Street" fullWidth />
          </Box>  
        </Grid>
        <Grid container />
        <Grid xs={12} sm={5}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Address.City" label="City" fullWidth />
          </Box>  
        </Grid>
        <Grid container />
        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <CountryField name="User.Address.CountryCode" label="Country Code"/>
          </Box>  
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Address.Zip" label="Zip" fullWidth />
          </Box>  
        </Grid>
        <Grid container />
        <Grid xs={12} sm={5}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField
              name="User.Address.Additional"
              label="Additional"
              fullWidth
            />
          </Box>  
        </Grid>
      </Grid>
    </>
  );
}
